module.exports = "/_next/static/media/Final-3 1.691c4314.png";